import React from 'react';
import type ServicedeskQueuesIssueViewRedirectType from '@atlassian/jira-spa-apps-servicedesk-queues-issue-view-redirect/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesIssueViewRedirect = lazyForPaint<
	typeof ServicedeskQueuesIssueViewRedirectType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-issue-view-redirect", jiraSpaEntry: "async-servicedesk-queues-issue-view-redirect" */ '@atlassian/jira-spa-apps-servicedesk-queues-issue-view-redirect'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskQueuesIssueViewRedirect}
		pageId="spa-apps/servicedesk/queues/issue-view-redirect"
		shouldShowSpinner
	/>
);
